export const environment = {
  production: true,
  apiUrl: 'https://offer.grigeopackaging.lt/api/',
  env: 'prod',
};
